<!-- 
  Refactored Records Page - Now uses the new architecture
  Following SOLID principles with proper separation of concerns
-->
<template>
  <!-- Use new RecordsPage component for cleaner architecture -->
  <RecordsPage 
    :member-line-id="memberLineId"
    :member-name="memberName"
    :group-id="groupId"
    :update-group-story-ship="updateGroupStoryShip"
    :update-finished-demo="updateFinishedDemo"
  />
</template>

<script>
import RecordsPage from './RecordsPage.vue';

/**
 * Wrapper component to maintain backwards compatibility
 * Delegates to the new refactored RecordsPage component
 */
export default {
  name: 'RecordsIndex',
  
  components: {
    RecordsPage
  },
  
  props: [
    'memberLineId', 
    'memberName', 
    'groupId', 
    'updateGroupStoryShip', 
    'updateFinishedDemo'
  ]
};
</script>

<style lang="scss" scoped>
// Styles are now handled by the RecordsPage component
// This maintains the same visual appearance while using the new architecture
</style>
